import React from "react";
import { Translation, t } from "../../../core/translate";
import { Button, TextField, Form } from "@vitalsource/vstui";
import SharedLinks from "../shared-links";
import { connect } from "react-redux";
import { selectors as brandSelectors } from "../../../../redux/brand";
import { actions as storageActions } from "../../../../redux/storage";
import {
  selectors as routerSelectors,
  actions as routerActions
} from "../../../../redux/router";
import {
  selectors as userSelectors,
  actions as userActions
} from "../../../../redux/user";
import { selectors as localeSelectors } from "../../../../redux/locale";
import Spinner from "../../../components/spinner";
import Benefits from "./benefits";
import { LockedEmail } from "../styles";
import FormAlert from "../form-alert";
import { emailPattern } from "../utils";
import { safeRedirect } from "../../../utils/location";
import Instructions from "./instructions";
import WelcomeText from "../welcome-text";

import ContainerLayout from "../container-layout";

class SignIn extends React.Component {
  constructor(props) {
    super(props);
    this.state = { email: false, emailStatus: {}, emailDomainError: false };
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      !prevState.email &&
      !prevState.emailStatus.exists &&
      this.state.email &&
      this.state.emailStatus.exists
    ) {
      this.password && this.password.focus();
    }
  }

  continue = () => {
    const { queryAfter, go } = this.props;
    queryAfter ? safeRedirect(queryAfter) : go("");
  };

  completeAccount = async e => {
    e.preventDefault();
    const email = this.email.value;

    // Check if account must be complete with custom email domain
    const validEmailDomain = this.validEmail(email);
    if (!validEmailDomain) {
      this.setState({ emailDomainError: true });
      return false;
    }

    // Verify this email and redirect to complete or show pwd to merge
    const emailStatus = await this.props.emailExists(email);
    if (emailStatus.exists) {
      // Time to merge!
      this.setState({ email, emailStatus });
    } else {
      // Redirect to finish completing and update info
      this.props.go("user/registration", {
        email,
        after: this.props.queryAfter
      });
    }
  };

  mergeAccount = e => {
    e.preventDefault();
    if (this.state.email && this.password) {
      this.props
        .mergeAccount(this.state.email, this.password.value)
        .then(({ success }) => {
          if (success) {
            // The router handles redirecting when no longer a reference use
          } else {
            this.setState({ signinError: true }, () => {
              this.formError && this.formError.focus();
            });
            // TODO something with this signin error
          }
        });
    }
  };

  skipCompletion = e => {
    e.preventDefault();
    this.props.skipSSO().then(this.continue);
  };

  resetEmail = () => {
    this.setState({ email: false, emailStatus: {} });
  };

  renderBenefits() {
    return this.props.showBenefits ? <Benefits /> : null;
  }

  validEmail = email => {
    const { validRegistrationDomains } = this.props;
    const domains = validRegistrationDomains;
    if (domains.length) {
      const emailDomain = email
        .substring(email.lastIndexOf("@") + 1)
        .toLowerCase();
      return domains.find(({ domain }) => domain.toLowerCase() === emailDomain);
    }
    return true;
  };

  renderEmail() {
    const { forceCompletion, validRegistrationDomains, brandName } = this.props;
    const brandDomains = validRegistrationDomains
      .map(function (el) {
        return el.domain;
      })
      .join(", ");
    const emailLabel = validRegistrationDomains.length
      ? t(
          "registration.to-begin-brand",
          "To begin, enter your institutional email.",
          { brand: brandName }
        )
      : t("registration.to-begin", "To begin, enter your email.");
    return (
      <Form
        onSubmit={this.completeAccount}
        id="complete-account-form"
        method="post"
        noValidate
        key="email-form"
        data-testid="emailForm"
      >
        <Instructions />
        <TextField
          required
          fullWidth
          data-testid="completionEmail"
          id="email-field"
          type="email"
          name="user[email]"
          nativeFormControlRef={x => (this.email = x)}
          label={emailLabel}
          size="large"
          pattern={emailPattern}
        />
        {this.state.emailDomainError && (
          <FormAlert level="error" key="signinerror">
            <span data-testid="errorAlert">
              {t(
                "signin.bad-domain",
                "Your email must end in a valid domain: ",
                {
                  domains: brandDomains
                }
              )}
            </span>
          </FormAlert>
        )}
        <Button id="submit-btn" fullWidth size="large">
          <Translation id="base.continue">Continue</Translation>
        </Button>
        {this.renderBenefits()}
        {!forceCompletion && (
          <Button
            id="skip-btn"
            fullWidth
            size="large"
            color="neutral"
            onClick={this.skipCompletion}
            type="button"
          >
            <Translation id="sso.skip-option">
              No thanks, I'll skip this step.
            </Translation>
          </Button>
        )}
      </Form>
    );
  }

  renderPassword() {
    return (
      <div>
        <Form
          onSubmit={this.mergeAccount}
          id="complete-account-form"
          method="post"
          noValidate
          key="password-form"
        >
          <div>
            <Translation id="sso.email-exists">
              Awesome, it looks like you already have an account.
            </Translation>
          </div>
          <LockedEmail>
            <span>{this.state.email}</span>
            <Button inline onClick={this.resetEmail} type="button">
              <Translation id="registration.change-email">
                (change email)
              </Translation>
            </Button>
          </LockedEmail>
          {this.state.signinError && (
            <FormAlert level="error" key="signinerror">
              {t("signin.failure", "Incorrect email or password")}
            </FormAlert>
          )}
          <TextField
            required
            fullWidth
            id="password-field"
            type="password"
            name="user[password]"
            label={t("base.password", "Password")}
            size="large"
            nativeFormControlRef={x => (this.password = x)}
          />
          <Button id="submit-btn" fullWidth size="large">
            <Translation id="base.continue">Continue</Translation>
          </Button>
        </Form>
        <SharedLinks forgotPassword />
      </div>
    );
  }

  render() {
    const { email, emailStatus } = this.state;
    const { redirectRoute, isNative } = this.props;
    let isbn = false;
    if (redirectRoute) {
      isbn = redirectRoute.relative.match(/books\/([^/|^?|^#]*)?\??/i);
      isbn = isbn ? isbn[1] : false;
    }
    return (
      <ContainerLayout
        graphic="signin"
        graphicBookCover={isbn}
        title={<WelcomeText />}
        aria-live="polite"
        pageTitle={t("sso.complete-your-account", "Complete Your Account")}
        isNative={isNative}
      >
        {email && emailStatus.exists
          ? this.renderPassword()
          : this.renderEmail()}
        {this.props.isMergingUser && <Spinner />}
      </ContainerLayout>
    );
  }
}

const mapStateToProps = state => ({
  showBenefits: brandSelectors.getBrandValue(
    state,
    "AccountCompletion.showBenefits",
    true
  ),
  validRegistrationDomains: brandSelectors.getBrandValue(
    state,
    "AccountCompletion.customDomains",
    []
  ),
  brandName: brandSelectors.getBrandValue(state, "name", "Bookshelf"),
  queryAfter: routerSelectors.getQueryParam(state, "after"),
  forceCompletion:
    routerSelectors.routeContains(state, "user/decide") ||
    brandSelectors.getBrandValue(state, "AccountCompletion.force", false),
  locale: localeSelectors.getCurrentLocale(state),
  isMergingUser: userSelectors.isMergingUser(state),
  redirectRoute: routerSelectors.getRedirectRoute(state),
  isNative: routerSelectors.isNative(state)
});

const mapDispatchToProps = dispatch => ({
  emailExists: email => dispatch(userActions.emailExists(email)),
  mergeAccount: (email, password) =>
    dispatch(userActions.mergeAccount(email, password)),
  skipSSO: () => {
    // TODO remove when old router is gone
    Fraction.Helpers.ssoSkipped = true;

    return dispatch(
      storageActions.setKey("skipSSO", true, {
        userScope: true,
        expires: 86400 // 24 hours
      })
    );
  },
  go: (dest, params) => dispatch(routerActions.go(dest, params))
});

const ConnectedSignin = connect(mapStateToProps, mapDispatchToProps)(SignIn);

export default ConnectedSignin;
